import { ref } from 'config/constants'
import _ from 'lodash';
import {
  FETCH_POSTS,
  
  FETCH_CATEGORIES,
  FETCH_MEDIAGROUPS,
  FETCH_PROVIDERS,
  FETCH_PERSONS,
  FETCH_PRODUCTS,
  FETCH_PRODUCTTYPES,
  FETCH_SEGMENTS,
  FETCH_ACCOUNT,
  //UPDATE_USERPROFILE
} from './types';

const Posts = ref.child("posts");
const Products = ref.child("products");
const ProductTypes = ref.child("productTypes");
const Categories = ref.child("categories");
const Accounts = ref.child("accounts");
const Mediagroups = ref.child("mediagroups");
const Providers = ref.child("providers");
const Persons = ref.child("persons");
const Segments = ref.child("segments");

export function fetchPosts() {
  return dispatch => {
    Posts.on('value', snapshot => {
      dispatch({
        type: FETCH_POSTS,
        payload: snapshot.val()
      });
    });
  };
}

export function createPost(post) {
  return dispatch => Posts.push(post);
}

export function deletePost(key) {
  return dispatch => Posts.child(key).remove();
}


/* CATEGORIES */
export function fetchCategories() {
  return dispatch => {
    Categories.on('value', snapshot => {
      dispatch({
        type: FETCH_CATEGORIES,
        payload: snapshot.val()
      });
    });
  };
}

export function createCategory(category) {
  return dispatch => Categories.push(category);
}

export function updateCategory(key, category) {
  return dispatch => Categories.child(key).set(category);
}

export function updateCategoriesuccess(key, category) {
  return dispatch => Categories.child(key).set(category);
}

export function deleteCategory(key) {
  return dispatch => Categories.child(key).remove();
}


/* MEDIAGROUPS */
export function fetchMediagroups() {
  return dispatch => {
    Mediagroups.on('value', snapshot => {
      dispatch({
        type: FETCH_MEDIAGROUPS,
        payload: snapshot.val()
      });
    });
  };
}

export function createMediagroup(mediagroup) {
  return dispatch => Mediagroups.push(mediagroup);
}

export function updateMediagroup(key, mediagroup) {
  return dispatch => Mediagroups.child(key).set(mediagroup);
}

export function updateMediagroupSuccess(key, mediagroup) {
  return dispatch => Mediagroups.child(key).set(mediagroup);
}

export function deleteMediagroup(key) {
  return dispatch => Mediagroups.child(key).remove();
}

/* PROVIDERS */
export function fetchProviders() {
  return dispatch => {
    Providers.on('value', snapshot => {
      dispatch({
        type: FETCH_PROVIDERS,
        payload: snapshot.val()
      });
    });
  };
}

export function createProvider(provider) {
  return dispatch => Providers.push(provider);
}

export function updateProvider(key, provider) {
  return dispatch => Providers.child(key).set(provider);
}

export function updateProviderSuccess(key, provider) {
  return dispatch => Providers.child(key).set(provider);
}

export function deleteProvider(key) {
  return dispatch => Providers.child(key).remove();
}

/* PERSONS */
export function fetchPersons() {
  return dispatch => {
    Persons.on('value', snapshot => {
      dispatch({
        type: FETCH_PERSONS,
        payload: snapshot.val()
      });
    });
  };
}

export function createPerson(person) {
  return dispatch => Persons.push(person);
}

export function updatePerson(key, person) {
  return dispatch => Persons.child(key).set(person);
}

export function updatePersonSuccess(key, person) {
  return dispatch => Persons.child(key).set(person);
}

export function deletePerson(key) {
  return dispatch => Persons.child(key).remove();
}


/* SEGMENTS */
export function fetchSegments() {
  return dispatch => {
    Segments.on('value', snapshot => {
      dispatch({
        type: FETCH_SEGMENTS,
        payload: snapshot.val()
      });
    });
  };
}

export function createSegment(segment) {
  return dispatch => Segments.push(segment);
}

export function updateSegment(key, segment) {
  return dispatch => Segments.child(key).set(segment);
}

export function updateSegmentSuccess(key, segment) {
  return dispatch => Segments.child(key).set(segment);
}

export function deleteSegment(key) {
  return dispatch => Segments.child(key).remove();
}

/* PRODUCTS */
export function fetchProducts() {
  return dispatch => {
    Products.on('value', snapshot => {
      dispatch({
        type: FETCH_PRODUCTS,
        payload: snapshot.val()
      });
    });
  };
}

export function createProduct(product) {
  return dispatch => Products.push(product);
}

export function updateProduct(key, product) {
  return dispatch => Products.child(key).set(product);
}

export function updateProductSuccess(key, product) {
  return dispatch => Products.child(key).set(product);
}

export function deleteProduct(key) {
  return dispatch => Products.child(key).remove();
}

/* PRODUCTTYPESS */
export function fetchProductTypes() {
  return dispatch => {
    ProductTypes.on('value', snapshot => {
      dispatch({
        type: FETCH_PRODUCTTYPES,
        payload: snapshot.val()
      });
    });
  };
}

export function createProductType(producttype) {
  return dispatch => ProductTypes.push(producttype);
}

export function updateProductType(key, producttype) {
  return dispatch => ProductTypes.child(key).set(producttype);
}

export function updateProductTypeSuccess(key, producttype) {
  return dispatch => ProductTypes.child(key).set(producttype);
}

export function deleteProductType(key) {
  return dispatch => ProductTypes.child(key).remove();
}

/* USER */
export function updateUserInfo(user, account) {
  return dispatch => user.updateUserInfo(account);
}


export function updateAccount(uid, account) {
  return dispatch => Accounts.child(uid).set(account);
}


export function fetchAccount(uid) {
  return dispatch => {
    Accounts.child(uid).on('value', snapshot => {
      if (snapshot.val() == null)
      {
        dispatch( updateAccount(uid, {name: ""}) );        
      }
      dispatch({
        type: FETCH_ACCOUNT,
        payload: snapshot.val()
      });
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/index.js